import { useTranslation } from "react-i18next";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Modal } from "components/designV2/modal/modal";
import { ErrorMessage } from "./profilePanel.changeToPermanentModal.styled";

interface ProfilePanelChangeToPermanentModalProps {
  readonly isOpen: boolean;
  readonly isSaving: boolean;
  readonly saveError: string;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}

export const ProfilePanelChangeToPermanentModal = (
  props: ProfilePanelChangeToPermanentModalProps,
): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={props.isOpen}
      onClose={props.onClose}
      size="compact"
      variant="confirm"
      showCloseButton={false}
      centerText
      label={t("Staff.ProfilePanelChangeToPermanentConfirmTitle")}
      footer={
        <>
          <SecondaryButton
            label={t("General.Cancel")}
            disabled={props.isSaving}
            onClick={props.onClose}
          />
          <PrimaryButton
            label={t("Staff.ProfilePanelChangeToPermanentConfirmAction")}
            isLoading={props.isSaving}
            disabled={props.isSaving}
            onClick={props.onConfirm}
          />
        </>
      }
    >
      {t("Staff.ProfilePanelChangeToPermanentConfirmBody")}
      {props.saveError.length > 0 && (
        <ErrorMessage role="alert">{props.saveError}</ErrorMessage>
      )}
    </Modal>
  );
};
